<template>
    <div>
        <!-- Preloader -->
        <PagePreloader v-if="!pageIsLoaded"></PagePreloader>

        <!-- Preloader -->
        <PagePreloader v-if="isSearching"></PagePreloader>

        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>

        <div class="row">
            <div class="col-xl-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header">
                        <div class="card-title">
                            <span class="card-icon">
                                <i class="fas fa-hashtag text-success"></i>
                            </span>
                            <h3 class="card-label">
                                Hashtag Search
                            </h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <form method="POST" v-on:submit.prevent="doRelevantSearch">
                            <!-- Hashtag input -->
                            <b-form-group label-cols="4" label-cols-lg="2" label="Hashtag">
                                <b-form-input
                                    placeholder="Enter your hashtag here"
                                    v-model="form.hashtag"
                                ></b-form-input>
                            </b-form-group>

                            <b-button
                                variant="success"
                                type="Submit"
                                class="d-none"
                                :disabled="isSearching"
                            >
                                Search
                            </b-button>
                        </form>
                    </div>
                    <div class="card-footer">
                        <b-button
                            variant="success"
                            class="offset-xl-2 col-xl-3"
                            @click="doRelevantSearch"
                            :disabled="isSearching"
                        >
                            Search
                        </b-button>
                    </div>
                </div>
                <!-- End search card -->

                <div class="card card-custom gutter-b" v-if="(results.length > 0)">
                    <div class="card-header">
                        <div class="card-title">
                            <h3 class="card-label">
                                Results
                            </h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <div
                            class="alert alert-custom alert-white shadow-sm fade show mb-5"
                            role="alert"
                        >
                            <div class="alert-icon">
                                <i class="flaticon-questions-circular-button text-success"></i>
                            </div>
                            <div class="alert-text">
                                The hashtags in each of these sections are ranked from most-relevant
                                to least-relevant.
                            </div>
                            <div class="alert-close">
                                <button
                                    type="button"
                                    class="close"
                                    data-dismiss="alert"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true"><i class="ki ki-close"></i></span>
                                </button>
                            </div>
                        </div>

                        <b-tabs pills content-class="mt-5" class="w-100 mt-5">
                            <b-tab
                                v-for="(result, index) in results"
                                :title="'#' + result.hashtag"
                                :key="index"
                                title-item-class="mytab"
                                :ref="'tabsRefs-' + index"
                            >
                                <div
                                    class="alert alert-custom alert-white shadow-sm fade show mb-5"
                                    role="alert"
                                >
                                    <div class="alert-text">
                                        We found
                                        <span class="badge badge-success">{{
                                            result.data.length
                                        }}</span>
                                        relevant hashtags for
                                        <code>#{{ result.hashtag }}</code>
                                    </div>
                                </div>

                                <div class="btn-group gutter-b" style="flex-wrap: wrap;">
                                    <div v-for="(hashtag, index) in result.data" :key="index">
                                        <span
                                            class="btn btn-sm btn-font-sm font-weight-bold btn-light-primary m-1"
                                        >
                                            #{{ hashtag }}
                                        </span>
                                    </div>
                                </div>

                                <div class="separator separator-dashed gutter-b"></div>

                                <div class="row">
                                    <!-- NOTE - Copy to Clipboard button -->
                                    <buttonCopyToClipboard
                                        :propHashtags="makeHashedHashtags(result.data)"
                                        class="col-md-3 col-12"
                                    ></buttonCopyToClipboard>
                                    <!-- NOTE - Analyse button -->
                                    <buttonScanInBulk
                                        variant="secondary"
                                        :propHashtags="makeHashedHashtags(result.data)"
                                        class="col-md-3 col-12"
                                    ></buttonScanInBulk>
                                    <!-- NOTE - Create new hashtag set -->
                                    <buttonCreateNewHashtagSet
                                        :propHashtags="makeHashedHashtags(result.data)"
                                        @emitPassMessage="handleEmitMessages"
                                        class="col-md-3 col-12"
                                    >
                                    </buttonCreateNewHashtagSet>
                                    <!-- NOTE - Add to existing hashtag set -->
                                    <buttonAddToExistingHashtagSet
                                        @emitPassMessage="handleEmitMessages"
                                        :propHashtags="makeHashedHashtags(result.data)"
                                        class="col-md-3 col-12"
                                    ></buttonAddToExistingHashtagSet>
                                </div>

                                <!-- <button
                                    class="btn btn-light-success col-xl-3 copy-hashtags-button mr-2 mb-4"
                                >
                                    <i class="far fa-clipboard"></i>
                                    <span class="innerText">Copy to clipboard</span>
                                </button>
                                <p class="copyHashtags" style="position: absolute; left: -999em;">
                                    {{ makeHashedHashtags(result.data) }}
                                </p>

                                <a
                                    @click="analyseHashtags(result.data)"
                                    class="btn btn-light-primary col-xl-3 mr-2 mb-4"
                                    >Analyse in Bulk</a
                                > -->
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
            <!-- End col 12 -->
        </div>
        <!-- End row -->
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>
<style scoped>
.tabs /deep/ .tab-pane:focus {
    outline: none;
}
.tabs /deep/ .mytab > .active {
    background-color: white;
    color: #1dc9b7;
    font-weight: 600;
}
.tabs /deep/ .mytab > .active a {
    border-bottom: 3px;
}
.tabs /deep/ .nav-pills {
    border-style: solid;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-color: rgba(29, 201, 183, 0.1);
}
</style>

<script>
// Defaults
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import InfoBox from "@/view/content/Custom/InfoBox.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
// Buttons
import buttonAddToExistingHashtagSet from "@/view/content/Custom/buttonAddToExistingHashtagSet.vue";
import buttonCreateNewHashtagSet from "@/view/content/Custom/buttonCreateNewHashtagSet.vue";
import buttonCopyToClipboard from "@/view/content/Custom/buttonCopyToClipboard.vue";
import buttonScanInBulk from "@/view/content/Custom/buttonScanInBulk.vue";
// Mixins
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "RelevantSearchPage",
    mixins: [axiosErrorManagement],
    components: {
        PagePreloader,
        CustomAlerts,
        InfoBox,
        buttonAddToExistingHashtagSet,
        buttonCreateNewHashtagSet,
        buttonCopyToClipboard,
        buttonScanInBulk,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,
            isSearching: false,

            // Displayers
            tabCount: 0,

            // Results
            results: [],

            // Error management
            errors: [],

            // Forms
            form: {
                hashtag: "",
            },
        };
    },

    methods: {
        // First method here
        doRelevantSearch() {
            // Reset errors
            this.errors = [];

            // Set preloader
            this.isSearching = true;

            // Perform query
            axios
                .post("search/relevant", {
                    hashtag: this.form.hashtag,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Do stuff
                        this.results.push({
                            hashtag: data.originalhashtag,
                            data: data.data,
                        });

                        // Get the newest tab index
                        var tabref = "tabsRefs-" + this.tabCount;
                        // Wait for it to generate before moving on
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.$refs[tabref][0].activate();
                                this.tabCount++;
                            }, 500);
                        });
                    }

                    // Check if we have any errors
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.errors.push({
                                type: item.type,
                                message: item.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Set preloader
                    this.isSearching = false;
                });
        },

        makeHashedHashtags(hashtags) {
            return "#" + hashtags.join(" #");
        },

        handleEmitMessages(messages) {
            if (messages.length > 0) {
                messages.forEach((currentItem) => {
                    this.errors.push({ type: currentItem.type, message: currentItem.message });
                });
            }
        },
    },

    mounted() {
        // Set page preloader
        this.pageIsLoaded = true;

        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Search", route: "search" },
            { title: "Relevant Search", route: "relevant" },
        ]);
    },
};
</script>
